import * as React from "react";
export default function LandingSubSection3(props){
    return(
        <section itemProp="offers" itemScope itemType="http://schema.org/AggregateOffer" id={'price'} className={'flex flex-col max-w-300 w-full mt-20 sm:mt-36 mb-10 sm:mb-0 px-5 laptop-xl:px-0'}>
            <h2 className={'pr-5 sm:pr-0 text-22px sm:text-46px text-black-1 font-black leading-relaxed sm:leading-snug'}>
                {props.title}
            </h2>
            <p className={'mt-6 sm:mt-12 text-sm sm:text-22px text-black-2 leading-loose sm:leading-relaxed'}>
                {props.textA}
            </p>
            <p className={'mt-6 sm:mt-12 text-sm sm:text-22px text-black-2 font-bold leading-loose sm:leading-relaxed'}>
                {props.textB}
            </p>
            <p className={'w-fit mt-6 sm:mt-10 py-1 xl:py-3 pr-2 text-lg xl:text-3xl text-black-1 font-bold price-bg'}>
                от {props.price} руб.
            </p>
            <meta itemProp="lowPrice" content={props.priceLow} />
            <meta itemProp="priceCurrency" content="RUB" />
        </section>
    )
}